import { BudgetPhases } from 'business/constants';
import {
    BUDGET_LINE_STATUS_READY,
    BUDGET_LINE_STATUS_TODO,
    BUDGET_LINE_STATUS_TO_VALIDATE,
    SERVICE_PROPOSAL,
    SERVICE_PROPOSAL_AMOUNT,
    SERVICE_PROPOSAL_COMMENT,
    SERVICE_PROPOSAL_ENDPOINT,
    SERVICE_PROPOSAL_ID,
    SERVICE_PROPOSAL_STATUS,
    SPLIT_BY,
} from 'routes/BudgetModule/config/constants';
import { StatusesSettingsT } from 'routes/BudgetModule/config/types';
import { isInscriptionRejected } from 'routes/BudgetModule/helpers/statusHelpers';
import { InscriptionT } from 'routes/BudgetModule/shared/entities/inscription';
import { translateMultipleName } from 'routes/BudgetModule/helpers/format';
import { PhaseHelpers } from '../phase';

const propositionConstants = {
    status: SERVICE_PROPOSAL_STATUS,
    inProgressStatus: BUDGET_LINE_STATUS_TODO,
    toValidateStatus: BUDGET_LINE_STATUS_TO_VALIDATE,
    doneStatus: BUDGET_LINE_STATUS_READY,
    comment: SERVICE_PROPOSAL_COMMENT,
    amount: SERVICE_PROPOSAL_AMOUNT,
    id: SERVICE_PROPOSAL_ID,
    table: SERVICE_PROPOSAL,
    endpoint: SERVICE_PROPOSAL_ENDPOINT,
    name: BudgetPhases.PROPOSITION_SERVICES,
    isEditable: true,
    isActive: true,
    isSimulated: false,
} as const;

const propositionHelpers: PhaseHelpers = {
    isInscriptionRejected: (
        inscription: InscriptionT,
        statusesSettings: StatusesSettingsT,
    ) =>
        isInscriptionRejected(
            inscription,
            propositionConstants.status,
            BudgetPhases.PROPOSITION_SERVICES,
            statusesSettings,
        ),
    getPhaseHeaderName: (exercice) =>
        translateMultipleName(
            `${propositionConstants.amount}${SPLIT_BY}${exercice}`,
        ),
} as const;

export const propositionPhase = {
    ...propositionConstants,
    ...propositionHelpers,
} as const;
